import { ReactElement } from 'react';
import DefaultProps from '../../commonTypes/defaultprops.types';
import Handler from '../../commonTypes/handler.types';
import {
  CustomMode,
  RailObject,
  HandlesObject,
  TracksObject,
  TicksObject,
} from 'react-compound-slider';

export interface SliderProps extends DefaultProps {
  maxValue: number;
  minValue?: number;
  defaultValues?: Array<number>;
  step?: number;
  mode?: 1 | 2 | 3 | CustomMode;
  vertical?: boolean;
  reversed?: boolean;
  handlers?: Handler;
  disabled?: boolean;
  trackLeft?: boolean;
  trackRight?: boolean;
  enableRailClick?: boolean;
  enableTrackClick?: boolean;
  tickValues?: Array<number>;
  showTickValues?: boolean;
  renderRail?: (railObject: RailObject) => ReactElement;
  renderHandles?: (handlesObject: HandlesObject) => ReactElement;
  renderTracks?: (tracksObject: TracksObject) => ReactElement;
  renderTicks?: (ticksObject: TicksObject) => ReactElement;
}

export interface RailProps {
  vertical?: boolean;
  theme: string;
}

export interface RailHotspotProps {
  vertical?: boolean;
}

export interface DotProps {
  left: string;
  vertical?: boolean;
  theme: string;
  isActive?: boolean;
}

export interface DotStyle {
  left?: string;
  top?: string;
}

export interface TrackProps {
  left: string;
  width: string;
  vertical?: boolean;
  theme: string;
}

export interface TrackStyle {
  left?: string;
  top?: string;
  width?: string;
  height?: string;
}

export interface TrackHotspotProps {
  left: string;
  width: string;
  vertical?: boolean;
}

export enum SliderTypes {
  PRIMARY = 'primary',
  DARK = 'dark',
}

export interface TickIndicatorProps {
  tickPercent?: number;
  vertical: boolean;
  theme: string;
}

export interface TickValueProps {
  tickPercent?: number;
  count: number;
  vertical: boolean;
  theme: string;
}
